import { Component, inject, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthApiService } from '@p2p/auth/api';
import { LS_TOKEN_KEY } from '@p2p/auth/domain';
import { SvgIcons } from '@p2p/shared/svg-icon';
import { LocalStorageService } from '@p2p/shared/utils';

import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
    readonly SvgIcons = SvgIcons;

    private readonly authApiService = inject(AuthApiService);
    private readonly localStorageService = inject(LocalStorageService);
    private readonly menuService = inject(MenuService);

    readonly account = toSignal(this.authApiService.account$);

    logout(): void {
        this.localStorageService.removeItem(LS_TOKEN_KEY);
        this.authApiService.logout('/');
    }

    openMenu(): void {
        this.menuService.openMenu();
    }
}
